import * as _actions from './actions';
import * as _accessors from './accessors';
import _reducer from './reducer';
import _User from './model';

_User.actions = _actions;
_User.accessors = _accessors;

export const actions = _actions;
export const accessors = _accessors;
export const reducer = _reducer;
export const User = _User;



// WEBPACK FOOTER //
// ./data/Users/index.js